import { NSARouterMakerResult } from 'namirasoft-account-react';
import { HistoryRow } from "namirasoft-history";
import { HistoryEntities } from '../HistoryEntities';
import { HistoryLayout } from '../HistoryLayout';
import { HistoryRouterProps } from '../HistoryRouterProps';
import NSHHistoryChanges from '../component/NSHHistoryChanges';

interface HistoryViewPageProps extends NSARouterMakerResult, HistoryRouterProps
{ }

function HistoryViewPage(props: HistoryViewPageProps)
{
    return (
        <HistoryLayout<HistoryRow>
            {...props}
            action={{
                title: "",
                description: "Get detailed insights into each activity. Review the specifics of every action performed within the products and services you use.",
                menus: {}
            }}
            pages={{
                entity: HistoryEntities.history(props, []),
                ui: {
                    action: {
                        menus: {
                            view_history: false
                        }
                    }
                },
                view: {
                    ui: {
                        tab_page_view: {
                            enabled: true,
                            tabs: {
                                history: false
                            }
                        },
                        getChildrenAfter: (id, entity) =>
                        {
                            return <NSHHistoryChanges props={props} id={id} row={entity} />;
                        }
                    }
                }
            }}
        >
            <></>
        </HistoryLayout>
    );
}

export default HistoryViewPage;